// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1admB","footer":"styles_footer__2GB3H"};